import { graphql } from '@/generated/gql';

export const INTAKE_REQUEST_DESCRIPTION_STEP_MUTATION = graphql(/* GraphQL */ `
  mutation IntakeRequestDescriptionStepMutation($data: SvbrgRequestDescriptionInput!) {
    sevenbridges {
      chatSession {
        requestDescription {
          next(data: $data) {
            id
            language
            text
          }
        }
      }
    }
  }
`);

export const INTAKE_REQUEST_DESCRIPTION_STEP_GENERATE_MUTATION = graphql(/* GraphQL */ `
  mutation IntakeRequestDescriptionStepGenerateMutation($data: SvbrgRequestDescriptionInput!) {
    sevenbridges {
      chatSession {
        requestDescription {
          generate(data: $data) {
            id
            text
            language
          }
        }
      }
    }
  }
`);
